import { useObserver } from 'mobx-react-lite';
import React from 'react';
import styled from 'styled-components/macro';
import { useAddressSelectStore } from '../models/AddressSelect';
import { AddressSelectProps } from '../types/AddressSelectProps';
import AddressSelectFormV2 from './AddressSelectFormV2';
import Button from './Button';

const UnstyledAddressSelect: React.FC<AddressSelectProps> = ({
  className,
  onEditAddressComplete,
}) => {
  const state = useAddressSelectStore();

  const onSave = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    if (state.hasPostcodeEntry) {
      state.onCalculateCart();
    }
    if (onEditAddressComplete) {
      onEditAddressComplete();
    }
  };

  return useObserver(() => (
    <span
      className={'ww-address-select-edit flex flex-col ' + (className || '')}
    >
      <AddressSelectFormV2 />
      <Button
        onClick={onSave}
        className="ww-address-select-button btn-v2 secondary mt-5"
      >
        Save
      </Button>
    </span>
  ));
};

const AddressSelectV2 = styled(UnstyledAddressSelect)``;

export default AddressSelectV2;
